import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';

/**
 * Component for presenting product share links.
 */
@Component({
	selector: 'product-share',
	templateUrl: './product-share.component.html',
	styleUrl: './product-share.component.css'
})
export class ProductShareComponent implements OnInit {
	@Input() product: any;

	LOCALIZATION: any;
	Object = Object;

	shareLink: { [key: string]: any } = {};
	inprogress: boolean = false;

	constructor(
		private ngbmodalService: NgbActiveModal,
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.getProductShareLinks();
	}

	/**
	 * Loads the share links for the product.
	 */
	getProductShareLinks(): void {
		this.inprogress = true;

		this.productService.getProductShareLinks(this.product.id).then(
			(response: any) => {
				this.shareLink = response;
				this.inprogress = false;
			},
			(err: any) => {
				console.error("Failed to load product share links", err);
				this.alertsService.error({
					message: "Failed to retrieve the share links for the product"
				});
				this.close();
			}
		);
	}

	/**
	 * Copies the link to the system clipboard.
	 */
	copyToClipboard(link?: string): void {
		if (link) {
			// Uses the JS Clipboard API
			// Not available for http, only https
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(link).then(() => {
					this.alertsService.info({
						message: this.LOCALIZATION.urlCopied
					});
				}).catch(err => {
					console.error("Failed to copy: ", err);
				});
			} else {
				this.fallbackCopyText(link);
			}
		}
	}

	private fallbackCopyText(text: string): void {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.select();

		try {
			// MDN recommends the Clipboard API instead of this deprecated method
			document.execCommand('copy');
			this.alertsService.info({
				message: this.LOCALIZATION.urlCopied
			});
		} catch (err) {
			console.error('Fallback copy failed:', err);
		}

		document.body.removeChild(textArea);
	}

	/**
	 * Opens the link in a new window.
	 */
	openLink(url: string): void {
		window.open(url, '_blank');
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
